import styled from 'styled-components';

export const InputDropDownWrapper = styled.div`
  .input-field {
    height: 32px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.ZenGray2};

    placeholder {
      color: ${({ theme }) => theme.colors.ZenGray2};
    }
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .provider-selector {
    .organisations-border {
      height: 32px;
      border-radius: 12px;
    }
    .mc-options {
      top: 32px;
    }
  }
`;
